export function getItemImageLabels({ attributes, customAttributes }, messages) {
    const labels = [];
    const itemLabel = attributes.find((el) => el.externalId === 'item_label');
    if (itemLabel) {
        itemLabel.values.forEach(({ externalId, value }) => {
            labels.push({
                text: value,
                labelName: externalId,
            });
        });
    }
    if (customAttributes && typeof customAttributes === 'object') {
        const bonus = customAttributes.bonus;
        if (bonus) {
            const text = messages['label.bonus'];
            text &&
                labels.push({
                    text: text.replace('{n}', bonus),
                    labelName: 'bonus',
                });
        }
    }
    return labels;
}
